export const MY_FOODS_PAGES = {
  MY_FOODS: "MY_FOODS",
  FOOD_DETAILS: "FOOD_DETAILS",
  EDIT_FOOD: "EDIT_FOOD",
  ADD_CUSTOM_FOOD: "ADD_CUSTOM_FOOD",
};
